import BaseHttpService from "../baseService";

class SecurityQuestionsServiceProvider extends BaseHttpService {
	constructor() {
		super("security-questions");
	}
}

const SecurityQuestionsService = new SecurityQuestionsServiceProvider();

export default SecurityQuestionsService;
